<script setup lang="ts">
    defineOptions({ name: 'SettingsPageLayout' });

    defineProps<{
        /** From lg, makes echo-table-wrapper--fill tables fill the scroll area below the header. */
        fillTable?: boolean;
    }>();
</script>
<template>
    <div class="w-full flex flex-col grow h-full">
        <div class="py-4.5 px-6 lg:px-12 flex border-b border-gray-lightest items-start">
            <div class="flex flex-col grow gap-1 py-1.5 pr-4 pl-8 sm:pl-0">
                <slot name="header" />
            </div>
            <div class="flex gap-3">
                <slot name="topbar" />
            </div>
        </div>
        <!-- Size container only from lg, where this area has a fixed height.
             The padding sits on the inner div so that 100cqh covers the whole area. -->
        <div
            class="w-full h-auto grow overflow-y-auto custom-scrollbar"
            :class="{
                'lg:[container-type:size] [--table-fill-space-below:2rem] lg:[--table-fill-space-below:3rem]':
                    fillTable,
            }"
        >
            <div class="px-6 lg:px-12 py-8 lg:py-12">
                <slot name="content" />
            </div>
        </div>
    </div>
</template>
